/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    QueueActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchQueueEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.QUEUE_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, QueueActions.receiveQueue))
);

export const updateQueueOrderEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.QUEUE_ORDER_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, QueueActions.confirmQueueOrder))
);

export const deleteQueueEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.QUEUE_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, QueueActions.deletedQueue))
);

export const updateQueueEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.QUEUE_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.post.id, action.post.item, QueueActions.updatedQueue))
);

export const fetchCalendarEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.QUEUE_CALENDAR_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.post.socialId, action.post, QueueActions.receiveCalendar))
);

export const fetchCalendarDetailEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.QUEUE_CALENDAR_DETAIL && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.post.socialId, action.post, QueueActions.receiveCalendarDetail))
);
